import { http } from '@/http'

// initial state
const state = {
  selectedProvince: '全国',
  selectedCity: '市县',
  countyList: [],
  provinceList: [],
  dateList: []
}
// getters
const getters = {}
// actions
const actions = {
  getCounty ({ commit }, { provinceId } = {}) {
    http.get('/canmou/tianji/my_locations', {
      params: { province_id: provinceId }
    }).then(res => {
      const data = res.data
      if (data.status === 0) {
        commit('setCountyList', data.data)
      }
    })
  },
  getProvince ({ commit }) {
    http.get('/canmou/tianji/my_province').then(res => {
      const data = res.data
      if (data.status === 0) {
        commit('setProvinceList', data.data)
      }
    })
  },
  getDates ({ commit }) {
    http.get('/canmou/tianji/dates').then(res => {
      const data = res.data
      if (data.status === 0) {
        commit('setDateList', data.data.items)
      }
    })
  }
}

// mutations
const mutations = {
  setCountyList (state, list) {
    state.countyList = list
  },
  setProvinceList (state, list) {
    state.provinceList = list
  },
  setDateList (state, list) {
    state.dateList = list
  },
  setSelectedProvince (state, province) {
    state.selectedProvince = province || '全国'
  },
  setSelectedCity (state, city) {
    state.selectedCity = city || '市县'
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
